import ContactLayout from "./contact-layout"

const ContactMain=()=>{
    return(
        <>
        <ContactLayout/>
        </>
    )
}

export default ContactMain 